module.exports = __webpack_public_path__ + "static/validated-straight-acc569f501d135c940008629bb6751b6.svg";